import * as React from "react";
import { useGetTemplatesQuery } from "../services/template.service";
import { Template } from "../types/template";
import SelectData from "./global/SelectData";

const SelectTemplate = ({
  onChange,
  sx,
  value,
  label = "Template",
  error,
  helperText,
}: {
  onChange: (arg?: number) => void;
  sx?: any;
  value: number;
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
}) => {
  const {
    data: templates,
    isLoading,
    isFetching,
  } = useGetTemplatesQuery({
    load: "customer,location",
  });

  return (
    <SelectData
      data={templates?.data}
      getOptionLabel={(template) =>
        `${template.title} [${
          !!template.customer
            ? template.customer?.first_name || "Customer not found"
            : template.location?.name || "Location not found"
        }]`
      }
      getOptionValue={(template) => template.id}
      value={value}
      onChange={(value) => onChange(value as number)}
          label={label}
          placeholder="Search template..."
          error={error}
          helperText={helperText}
      isLoading={isLoading}
      isFetching={isFetching}
      sx={sx}
    />
  );
};
export default SelectTemplate;
